<!-- 机构-课程评价管理 -->
<template>
  <div class="index">
      <div class="title">
        <span>{{ $route.name }}</span>
      </div>
      <div class="query">
        <div class="query">
          <el-form ref="form" :inline="true" :model="queryParams">
            <el-form-item label="" label-width="40px">
              <el-select v-model="queryParams.star" clearable placeholder="选择星级" class="label">
                <el-option v-for="item in starList" :key="item.id+'rating'" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input type="text" placeholder="请输入学校名称" v-model="queryParams.schoolName"></el-input>
            </el-form-item>
				    <el-form-item label="">
              <el-input type="text" placeholder="请输入课程名称" v-model="queryParams.cname"></el-input>
            </el-form-item>
            <el-form-item label="">
            <el-date-picker v-model="queryParams.date" type="daterange" style="width: 240px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="cname" label="评价课程" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="evalUsername" label="评价人" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="evalUsertype" label="身份" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{userType[scope.row.evalUsertype]}}</p>
						</template>
          </el-table-column>
          
          <el-table-column prop="evalUserOrganame" label="学校" align="center" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="evalUserClassname" label="班级" align="center">
          </el-table-column> -->
          <el-table-column prop="rating" label="评价星级" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{scope.row.rating}}星</p>
						</template>
          </el-table-column>
					<el-table-column prop="content" label="评价内容" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="evalTime" label="评价时间" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{dayjs(scope.row.evalTime).format('YYYY-MM-DD HH:mm')}}</p>
						</template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize" :total="queryParams.totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import mechanismApi from "@/api/mechanismApi/curriculum.js"
export default {
  components: {
  },
  data() {
    return {
      queryParams: {
				cname: '',
				schoolName:'',
				star: '',
				date:'',
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
			},
      tableData: [],
      starList: [
				{id:1,label:'1星'},
				{id:2,label:'2星'},
				{id:3,label:'3星'},
				{id:4,label:'4星'},
				{id:5,label:'5星'},
			],
      userType:{
				'0':'学生',
				'1':'老师',
				'2':'家长',
			},
    };
  },
  mounted() {},
  created() {
    this.getDataList();
  },
  methods: {
    dayjs,
		async getDataList() {
			let that=this.queryParams;
			let obj={};
			if(that.date){
				obj.startTime=dayjs(that.date[0]).format('YYYY-MM-DD');
				obj.endTime=dayjs(that.date[1]).format('YYYY-MM-DD');
			}
			if(that.cname){
				obj.cnameKey=that.cname;
			}
			if(that.schoolName){
				obj.schoolNameKey=that.schoolName;
			}
			if(that.star){
				obj.rating=that.star;
			}
			let params = {
				pageNum:that.pageNum,
				pageSize:that.pageSize,
			}
			params={...params,...obj};
			let {result, data} = await mechanismApi.getEnterpriseCourseEvaluateList(params);
			if(result==='000000'){
				this.tableData=data.list || [];
				that.totalPage=data.total || 0;
			}
		},
    searchFun(){
			this.queryParams.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.queryParams.pageSize = val;
			this.getDataList();
		},
		currentChangeHandle(val) {
			this.queryParams.pageNum = val;
			this.getDataList();
		},
  },
};
</script>
<style lang="less" scoped>
.index {
	width: 100%;
  padding: 0px 30px 30px 30px;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
::v-deep .el-form .el-input__inner {
  width: 150px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>
